import styled from 'styled-components';
import { animated } from 'react-spring/renderprops.cjs';
import glassesEmoji from 'images/icons/glassesEmoji.svg';
import lightBulb from 'images/icons/lightBulb.png';
import checkmark from 'images/blueCheckMark.svg';
import xButton from 'images/xButton.svg';

const alertToIconMap = {
  report: glassesEmoji,
  insight: lightBulb,
  action_required: glassesEmoji,
};

const dropdownIconMap = {
  check: checkmark,
  close: xButton,
};

export const NotificationDropdownContainer = styled.div`
  color: #323848;
  position: absolute;
  font-size: 19px;
  letter-spacing: 2px;
  display: inline-block;
  top: 49px;
  opacity: 0;
  transition: all .3s ease;
`;

export const Dropdown = styled.div`
  position: absolute;
  right: 0px;
  background: white;
  z-index: 2;
  white-space: nowrap;
  border-radius: 5px;
  padding: 8px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
`;

export const DropdownIcon = styled.div`
  background-color: #F3F4F5;
  border-radius: 100%;
  width: 19px;
  height: 19px;
  display: inline-block;
  background-position: center;
  background-image: ${({ icon }) => `url(${dropdownIconMap[icon]})`};
  background-size: 9px 9px;
  background-repeat: no-repeat;
  vertical-align: text-top;
  margin-right: 10px;
  transition: all .3s ease;
`;

export const DropdownOption = styled.div`
  padding: 3px 13px;
  border-radius: 2px;
  line-height: 20px;
  margin-bottom: 2px;
  font-size: 13px;
  transition: all .3s ease;
  letter-spacing: normal;
  &:hover {
    background: #F3F4F5;
    ${DropdownIcon} {
      background-color: white;
    }
  }
`;

export const AnimationContainer = styled(animated.div)`
  overflow: ${({ allowOverflow }) => allowOverflow ? 'visible' : 'hidden'};
`;

export const Container = styled.div`
  display: block;
  position: relative;
  padding: 20px 12px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.07);
  transition: all .3s ease;
  border-radius: 6px;
  margin-bottom: 7px;
  background: white;
  overflow: ${({ allowOverflow }) => allowOverflow ? 'visible' : 'hidden'};

  &:hover {
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.2);
    ${NotificationDropdownContainer} {
      opacity: 0.3;
      &:hover {
        opacity: 1;
        cursor: pointer;
      }
    }
  }

  &:last-child {
    ${Dropdown} {
      bottom: 0;
    }
  }
`;

export const IconContainer = styled.div`
  display: inline-block;
  width: 20%;
  vertical-align: middle;
  text-align: left;
`;

export const Icon = styled.div`
  border-radius: 4px;
  height: 30px;
  width: 30px;
  background-image: ${({ type }) => `url(${alertToIconMap[type]})`};
  background-position: center;
  background-size: cover;
  margin: auto;
  margin-left: 33%;
`;

export const TextContainer = styled.div`
  display: inline-block;
  width: ${({ showOptions }) => showOptions ? '72%' : '80%'};
  padding-left: 6%;
  vertical-align: middle;
  text-align: left;
  padding-right: 15px;
  height: 70px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #939AAB;
  margin-bottom: 7px;
`;

export const NotificationText = styled.div`
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #CBCED6;
  margin-top: ${({ marginTop }) => marginTop || 0};
  height: 34px;
  overflow: hidden;
`;

export const DateText = styled(NotificationText)`
  height: auto;
  color: ${({ seen, theme }) => seen ? '#CBCED6' : theme.colors.palette[7]};
`;

export const Close = styled.div`
  position: absolute;
  top: 8px;
  right: 18px;
  font-size: 28px;
  color: #CBCED6;
  cursor: pointer;
`;
